import React from 'react';

import {toHumanReadableDate} from '../../../../utils/date';

import './ResultDate.scss';

interface LastResultDateProps {
  result: any;
  loading?: boolean;
}

export const ResultDate = ({
  result,
  loading,
}: LastResultDateProps) => {
  if (!result || loading) {
    return null;
  }
  const timeAgo = toHumanReadableDate(result?.value?.created_on) || 'No date';

  return (
    <div className="result-date">
      <span>{timeAgo}</span>
    </div>
  )
};

export default ResultDate;
